import "./RegistrationGroup.css";

import { Breadcrumb, message, Table, type TableColumnsType, Tag } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import {
  deleteRegistrationGroup,
  getRegistrationGroups,
  type RegistrationGroupType,
  useAppSelector,
} from "../../_lib/_store";

export const RegistrationGroupPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, registrationGroups } = useAppSelector(
    (state) => state.registrationGroup,
  );
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getRegistrationGroups(messageApi);
  };

  const columns: TableColumnsType<RegistrationGroupType> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      render: (_, obj) => (
        <div>{obj?.tags?.map((v) => v?.name).join(", ")}</div>
      ),
    },
    {
      title: "Packages",
      dataIndex: "packages",
      key: "packages",
      render: (_, obj) => (
        <div>{obj?.packages?.map((v) => v?.name).join(", ")}</div>
      ),
    },
    {
      title: "Registration No",
      dataIndex: "registrationNo",
      key: "registrationNo",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Audit Type",
      dataIndex: "auditType",
      key: "auditType",
      render: (t) => <Tag color="gray">{t}</Tag>,
    },
    {
      title: "Personal Notes",
      dataIndex: "personalNotes",
      key: "personalNotes",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: RegistrationGroupType) => {
    switch (key) {
      case "show":
        navigate(`/registration-group/show`, {
          state: { registrationGroup: obj },
        });
        break;
      case "edit":
        navigate(`/registration-group/edit`, {
          state: { registrationGroup: obj },
        });
        break;
      case "delete":
        deleteRegistrationGroup(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="tag">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "Registration Group",
              },
            ]}
          />
        </div>
        <SectionHeader
          dataLength={registrationGroups?.length}
          createRoute="registration-group"
        />
        <Table
          sticky
          dataSource={registrationGroups}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1300 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
